import getLang from 'I18n/utils/getLang';
const getUserPreferences = state => state.userPreferences;
export const getUserPreferenceRequestState = state => getUserPreferences(state).requestState;
export const getUserPreferredLocale = state => getUserPreferences(state) && Object.keys(getUserPreferences(state).userPreferences).length ? getUserPreferences(state).userPreferences.locale : getLang();